export const Bio = {
  name: "Prajjwal Rai",
  roles: [
    "Full Stack Developer",
    "Programmer",
    "Android Developer",
  ],
  description:
    "I’m a passionate Full Stack Developer with a strong focus on building dynamic, responsive, and user-friendly web applications. I love turning ideas into reality using the power of the MERN stack, and I’m always eager to learn new technologies that push my limits as a developer.",
  github: "https://github.com/prajjwalrai",
  resume:
    "https://drive.google.com/file/d/1txFKZD3LNIXMc329jD9c995AU8LItOXK/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/prajjwalrai4/",
  twitter: "https://x.com/Prajjwal1597493",
  insta: "https://www.instagram.com/prajjwal_0621/",
  facebook: "https://www.facebook.com/profile.php?id=61583613420103",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
       {
        name: " Tailwind CSS",
        image:
          "https://images.seeklogo.com/logo-png/35/2/tailwind-css-logo-png_seeklogo-354675.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Grafana",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Jetpack Compose",
        image:
          "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://images.seeklogo.com/logo-png/27/2/netlify-logo-png_seeklogo-273744.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

// export const experiences = [
//   {
//     id: 0,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
//     role: "Frontend Engineer Intern",
//     company: "Neurobit",
//     date: "June 2023 - Nov 2023",
//     desc: "Enhanced user experiences on Neurobit PSG & Hybrid, Portals by resolving bugs & reduced load time by 40%. Built Neurobit Analytics portal using React Js with seamless interaction of REST APIs using AXIOS optimized with React Query. Refactored previous code to TypeScript, updated with new dependency and integrated Vite with Jest for Unit Testing.",
//     skills: [
//       "ReactJS",
//       "Redux",
//       "NodeJs",
//       "Material UI",
//       "HTML",
//       "CSS",
//       "JavaScript",
//     ],
//     doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
//   },
//   {
//     id: 1,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
//     role: "DevOps & Fullstack Engineering Intern",
//     company: "Flipr Inovations Pvt. Ltd.",
//     date: "Aug 2023 - Oct 2023",
//     desc: "Built Flipr Connect Platforms using React Js integrated GraphQL with AXIOS, created High level Design and Figma design. Built Backend with GraphQL and Node JS and connected with MongoDb - Reducing API calls by 20%. Dockerized and automated with Kubernetes & Jenkins CI/CD deployed in AWS-EC2 added Prometheus & Grafana for monitoring.",
//     skills: [
//       "Docker",
//       "Terraform",
//       "AWS",
//       "EC2",
//       "Portainer",
//       "Nginx",
//       "JavaScript",
//       "TypeScript",
//       "Node Js",
//       " Next Js",
//     ],
//     doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
//   },
//   {
//     id: 2,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
//     role: "Android Developer Intern",
//     company: "Rudraksha Welffare Foundation",
//     date: "June 2021 - Oct 2021",
//     desc: "• Built RudraShakti - Astrologer App, with MVVM Architecture using Java and Android Studio integrating Firebase SDK. Created One to One video call integration with Socket.IO and Firebase cloud functions and integrated with Retrofit. Created Low Level Design and converted Figma design to XML code.",
//     skills: [
//       "Android",
//       "Java",
//       "Kotlin",
//       "XML",
//       "Node Js",
//       "Cloud Firestore",
//       "Firebase",
//       "Figma",
//     ],
//     doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
//   },
//   {
//     id: 3,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
//     role: "Fullstack Externship",
//     company: "Flipr",
//     date: "June 2023 - July 2023",
//     desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
//     skills: [
//       "ReactJS",
//       "Redux",
//       "NodeJs",
//       "Material UI",
//       "HTML",
//       "CSS",
//       "JavaScript",
//       "Docker",
//       "AWS",
//       "MongoDB",
//     ],
//     doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
//   },
//   {
//     id: 4,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
//     role: "Android Developer",
//     company: "DSC KIIT",
//     date: "Nov2021 - Present",
//     desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
//     skills: [
//       "Leadership",
//       "Mobile Application Development",
//       "Kotlin",
//       "XML",
//       "Figma",
//     ],
//   },
//   {
//     id: 5,
//     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
//     role: "Open Source Contributor ",
//     company: "GirlScript Summer of Code",
//     date: "May 2023 - Present",
//     desc: "Contributed to different open-source projects and learn from industry experts",
//   },
// ];

export const education = [
  {
    id: 0,
    img: "https://images.seeklogo.com/logo-png/34/2/lpu-sae-india-collegiate-club-logo-png_seeklogo-345773.png",
    school: "Lovely Professional University, Phagwara, Punjab",
    date: "Aug 2023 - July 2027",
    grade: "8.21 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Lovely Professional University, Phagwara, Punjab . I have completed 4 semesters and have a CGPA of 8.21. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at LPU, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKolZv3P-SL3zNZeBRGd9rY3r6vltAk1ntUVmvtAf5Lw&s",
    school: "Rainbow modern School, Ghazipur ,Uttar Pradesh",
    date: "Apr 2021 - Apr 2023",
    grade: "85.6%",
    desc: "I completed my class 12 high school education at Rainbow Modern School, Ghazipur, where I studied Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer",
  },
  {
    id: 2,
    img: "data:image/jpeg;base64,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",
    school: "Vidya Public School, Ghazipur, Uttar Pradesh",
    date: "Apr 2019 - Apr 2021",
    grade: "91.0%",
    desc: "I completed my class 10 education at Vidya Public School, Ghazipur, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 11,
    title: "Agroshield",
    date: "march 2025 - Aprail 2025",
    description:
      "AgroShield is a responsive static website that helps farmers identify and manage crop pests through detailed guides and eco-friendly strategies. Built with HTML, CSS, JavaScript, and Tailwind CSS, it provides a user-friendly platform promoting sustainable agriculture and improved crop yield",
    image:
      "/assets/Agroshield.png",
    tags: [
      "React Js",
      "PostgressSQL",
      "Node Js",
      "Express Js",
      "Redux",
      "React Flow",
    ],
    category: "web app",
    github: "https://github.com/prajjwalrai/agroshield-platform",
    webapp: "",
  },
  {
    id: 9,
    title: "Mental Health Chatbot",
    date: "feb 2025 - march 2025",
    description:
      "Developed an AI-powered mental health chatbot using Python and TensorFlow to provide users with emotional support and coping strategies. Implemented natural language processing (NLP) techniques to understand user inputs and deliver personalized responses. Integrated the chatbot into a web application using Flask, ensuring accessibility across devices. Conducted user testing to refine the chatbot's effectiveness and user experience.",
    image:
      "/assets/ai_chatbot.png",
    tags: [
      "Docker",
      "AWS",
      "DuckDNS",
      "Eslint",
      "Husky",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "web app",
    github: "https://github.com/prajjwalrai/ai-chatbot-webapp",
    webapp: "",
  },
  // {
  //   id: 0,
  //   title: "Podstream",
  //   date: "Apr 2023 - May 2023",
  //   description:
  //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
  //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Podstream",
  //   webapp: "https://podstream.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  {
    id: 1,
    title: "Two Good store",
    date: "Oct 2024 - Jan 2024",
    description:
      "Two Good Co is a static website project designed to provide a seamless and engaging user experience. With a focus on simplicity, elegance, and responsiveness, this project aims to empower businesses and individuals to establish a strong online presence.",
    image:
      "/assets/twogood.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://vexa-app.netlify.app/",
  },
  // {
  //   id: 2,
  //   title: "Brain Tumor Detection",
  //   date: "Jan 2023 - Mar 2023",
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
  //   webapp: "https://brain-tumor.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "https://camo.githubusercontent.com/3ad28aa710d18525f1fc87de056ed53c706d09979589bfd5a773df36653bad38/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
  //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  // },
  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];

